import PrimaryLarge from "./PrimaryLarge";

export default PrimaryLarge;
export { PrimaryLarge as H1 };
